// AppRouter.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { topicGroups } from './topicGroups';
import LandingPage from './LandingPage';
import AgeGate from './AgeGate';

const TopingoGame = lazy(() => import('./TopingoGame'));
const DailyGame = lazy(() => import('./DailyGame'));
const TopicLanding = lazy(() => import('./TopicLanding'));
const TopicDirectory = lazy(() => import('./TopicDirectory'));
const AboutPage = lazy(() => import('./AboutPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));
const ContactPage = lazy(() => import('./ContactPage'));
const TermsPage = lazy(() => import('./TermsPage'));
const AdvertiserLeaderboardPage = lazy(() => import('./AdvertiserLeaderboardPage'));
const AdvertiseCheckoutPage = lazy(() => import('./AdvertiseCheckoutPage'));
const AdvertiseThankYouPage = lazy(() => import('./AdvertiseThankYouPage'));
const WordleFatiguePage = lazy(() => import('./WordleFatiguePage'));
const WordleTooEasyPage = lazy(() => import('./WordleTooEasyPage'));
const FandomWordlePage = lazy(() => import('./FandomWordlePage'));

const topics = Object.keys(topicGroups);
const randomTopic = topics[Math.floor(Math.random() * topics.length)];
const defaultRoute = `/play/${randomTopic}`;

const AppRouter = () => {
  return (
    <Router>
      <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play" element={<Navigate to={defaultRoute} replace />} />
        <Route path="/play/:topicName" element={<TopingoGame />} />
        <Route path="/play/:topicName/:wordId" element={<TopingoGame />} />
        <Route path="/daily" element={<Navigate to="/daily/english" replace />} />
        <Route path="/daily/:topic" element={<DailyGame />} />
        <Route path="/topic/:topicName" element={<TopicLanding />} />
        <Route path="/topic/:topicName/" element={<TopicLanding />} />
        <Route path="/topics" element={<TopicDirectory />} />
        <Route path="/topics/" element={<TopicDirectory />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/advertisers" element={<AdvertiserLeaderboardPage />} />
        <Route path="/bid" element={<AdvertiseCheckoutPage />} />
        <Route path="/bid/thank-you" element={<AdvertiseThankYouPage />} />
        <Route path="/wordle-alternatives" element={<WordleFatiguePage />} />
        <Route path="/wordle-too-easy" element={<WordleTooEasyPage />} />
        <Route path="/wordle-too-easy/" element={<WordleTooEasyPage />} />
        <Route path="/fandom-wordle" element={<FandomWordlePage />} />
        <Route path="/fandom-wordle/" element={<FandomWordlePage />} />

      </Routes>
      </Suspense>
      <AgeGate />
    </Router>
  );
};


export default AppRouter;